export const onceUponTomorrowAbi = [{
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
}, {
    inputs: [{
        internalType: 'uint256',
        name: 'numerator',
        type: 'uint256'
    }, { internalType: 'uint256', name: 'denominator', type: 'uint256' }],
    name: 'ERC2981InvalidDefaultRoyalty',
    type: 'error'
}, {
    inputs: [{ internalType: 'address', name: 'receiver', type: 'address' }],
    name: 'ERC2981InvalidDefaultRoyaltyReceiver',
    type: 'error'
}, {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }, {
        internalType: 'uint256',
        name: 'numerator',
        type: 'uint256'
    }, { internalType: 'uint256', name: 'denominator', type: 'uint256' }],
    name: 'ERC2981InvalidTokenRoyalty',
    type: 'error'
}, {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }, {
        internalType: 'address',
        name: 'receiver',
        type: 'address'
    }], name: 'ERC2981InvalidTokenRoyaltyReceiver', type: 'error'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'approved', type: 'address' }, {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
    }],
    name: 'Approval',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'operator', type: 'address' }, {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
    }],
    name: 'ApprovalForAll',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'OwnershipTransferred',
    type: 'event'
}, {
    anonymous: false,
    inputs: [{
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
    }, { indexed: true, internalType: 'address', name: 'to', type: 'address' }, {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
    }],
    name: 'Transfer',
    type: 'event'
}, {
    inputs: [],
    name: 'HELMETS_PROVENANCE',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'MAX_HELMETS',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'to', type: 'address' }, {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
    }], name: 'approve', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'address', name: '', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'baseURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint96', name: 'newRoyalty', type: 'uint96' }],
    name: 'changeDefaultRoyalty',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'price', type: 'uint256' }],
    name: 'changeHelmetPrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [],
    name: 'flipSaleState',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'helmetPrice',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'owner', type: 'address' }, {
        internalType: 'address',
        name: 'operator',
        type: 'address'
    }],
    name: 'isApprovedForAll',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'maxHelmetPurchase',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'numberOfTokens', type: 'uint256' }],
    name: 'mintHelmets',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
}, {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'owner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'premintValue',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{
        internalType: 'uint256',
        name: 'numberOfTokens',
        type: 'uint256'
    }, { internalType: 'address', name: 'to', type: 'address' }],
    name: 'reserveHelmets',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }, {
        internalType: 'uint256',
        name: 'salePrice',
        type: 'uint256'
    }],
    name: 'royaltyInfo',
    outputs: [{ internalType: 'address', name: '', type: 'address' }, {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
    }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'from', type: 'address' }, {
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'from', type: 'address' }, {
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { internalType: 'uint256', name: 'tokenId', type: 'uint256' }, {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes'
    }], name: 'safeTransferFrom', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [],
    name: 'saleIsActive',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'operator', type: 'address' }, {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
    }], name: 'setApprovalForAll', outputs: [], stateMutability: 'nonpayable', type: 'function'
}, {
    inputs: [{ internalType: 'string', name: 'baseURI_', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'price', type: 'uint256' }],
    name: 'setHelmetPrice',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'string', name: 'provenanceHash', type: 'string' }],
    name: 'setProvenanceHash',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'symbol',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'index', type: 'uint256' }],
    name: 'tokenByIndex',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [],
    name: 'totalSupply',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'from', type: 'address' }, {
        internalType: 'address',
        name: 'to',
        type: 'address'
    }, { internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}, {
    inputs: [],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
}] as const;
